import SerachMainComp from "./SerachMainComp";

export default SerachMainComp;
